import React, { useState, useRef } from "react";

const UploadMessage = ({ Question, onUpload, chatContainerRef }) => {
    const [files, setFiles] = useState([]);
    const [uploadProgress, setUploadProgress] = useState({});
    const [uploadStarted, setUploadStarted] = useState(false); // ✅ Track Upload Start
    const fileInputRef = useRef(null);

    const handleFileButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);

        if (selectedFiles.length > 0) {
            setUploadStarted(true); // ✅ Hide Upload Button Immediately
        }

        // ✅ Store files in state
        setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);

        // ✅ Upload Each File
        selectedFiles.forEach((file) => {
            setUploadProgress((prev) => ({ ...prev, [file.name]: 0 }));
            simulateUpload(file);
        });
    };

    const simulateUpload = (file) => {
        let uploadedChunks = 0;
        const totalChunks = 100;

        const interval = setInterval(() => {
            if (uploadedChunks < totalChunks) {
                uploadedChunks += 10;
                setUploadProgress((prev) => ({ ...prev, [file.name]: uploadedChunks }));
            } else {
                clearInterval(interval);
                onUpload(file.name, file); // Call upload function after completion

                // ✅ Scroll to bottom after each upload
                setTimeout(() => {
                    if (chatContainerRef?.current) {
                        chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
                    }
                }, 100);
            }
        }, 500);
    };

    return (
        <div className="left-chatbot-message-section">
            <div className="input-type-text-response">
                <div className="input-type-text-response-content">
                    {/* ✅ Hide Upload Button Immediately After File Selection */}
                    {!uploadStarted && (
                        <div className="input-type-text-response-content-option">
                            <input
                                type="file"
                                className="custom-input-file"
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                multiple
                                style={{ display: "none" }}
                            />
                            <label className="custom-file-upload" onClick={handleFileButtonClick}>
                                <img src="/images/document-upload-icon.png" alt="upload-icon" />
                                {Question}
                            </label>
                        </div>
                    )}

                    {/* ✅ Show Each File's Upload Progress */}
                    {files.map((file) => (
                        <div key={file.name} className="upload-progress-container">
                            <div className="upload-progress">
                                <div className="upload-progress-heading">
                                    <img src="/images/pdf-icon.png" alt="pdf-icon"/>
                                    <div className="file-name">{file.name}</div>
                                    <div className="cancel-button">
                                        <img src="/images/upload-cancel-button.png" alt="cancel-button"/>
                                    </div>
                                </div>

                                <div className="upload-progress-report">
                                    <div className="upload-progress-bar" style={{ width: `${uploadProgress[file.name]}%` }}></div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default UploadMessage;